<script setup lang="ts">
import { computed } from 'vue'
import RatingStars from './RatingStars.vue'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<{
    rating: number | null | undefined
    googleRating: number | null | undefined
    compact?: boolean
}>(), { compact: true })


// @ts-ignore
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

const resolved = computed(() => {
    if (props.rating !== null && props.rating !== undefined) {
        return { value: Number(props.rating), logo: VITE_ASSET_URL + 'assets/logo/topela-rating-logo.svg', alt: 'Topela' }
    }
    if (props.googleRating !== null && props.googleRating !== undefined) {
        return { value: Number(props.googleRating), logo: VITE_ASSET_URL + 'assets/logo/google-rating-logo.webp', alt: 'Google' }
    }
    return null
})
</script>

<template>
    <div v-if="resolved" v-bind="$attrs" class="d-flex align-items-center" :class="{ 'gap-1': props.compact }">
        <img :src="resolved.logo" height="18" :alt="resolved.alt" :class="{ 'me-1': !props.compact }" />
        <RatingStars :value="resolved.value" />
    </div>
    <span v-else v-bind="$attrs" class="rating-value text-muted">—</span>
</template>
